var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackIcon = function SvgBackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65554 16.4228L3.8222 10.5895C3.49677 10.264 3.49677 9.73641 3.8222 9.41097L9.65554 3.57764L10.834 4.75615L5.58997 10.0002L10.834 15.2443L9.65554 16.4228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6555 16.4228L8.8222 10.5895C8.49677 10.264 8.49677 9.73641 8.8222 9.41097L14.6555 3.57764L15.834 4.75615L10.59 10.0002L15.834 15.2443L14.6555 16.4228Z",
    fill: "white"
  }))));
};
export { SvgBackIcon as ReactComponent };
export default __webpack_public_path__ + "assets/676c95ce.svg";